import gsap from "gsap";
import { DrawSVGPlugin, ScrollTrigger, CustomEase } from "gsap/all";
import DefaultBlock from "/scripts/default/block";
import { watchPreferredMotion } from "/utils/helpers/watchPreferredMotion";

// Register Plugins
gsap.registerPlugin(DrawSVGPlugin, ScrollTrigger, CustomEase);

export default class ScrollSmoothBreeze extends DefaultBlock {
	// Define variables
	init() {
		const selector = gsap.utils.selector(this.block);

		const DOM = {
			wrap: selector(".scroll-smooth-breeze__plane-wrap"),
			path: selector("#scroll-plane-path-core path"),
			pathTop: selector("#scroll-plane-path-top path"),
			pathBottom: selector("#scroll-plane-path-bottom path"),
			plane: selector("#scroll-plane"),
			planeGroup: selector("#scroll-plane g"),
		};
		this.DOM = DOM;

		this.defaults = {
			ease: "power3.out",
			duration: 3,
		};

		this.tl = this.createTimeline();
	}

	planeFlight() {
		const tl = gsap.timeline({
			defaults: this.defaults,
			scrollTrigger: {
				invalidateOnRefresh: true,
				scrub: 3,
				trigger: this.DOM.wrap,
				start: "top 75%",
				end: "bottom 25%",
			},
		});

		gsap.set([this.DOM.path, this.DOM.pathTop, this.DOM.pathBottom], {
			drawSVG: "0%",
		});

		tl.to(this.DOM.plane, {
			motionPath: {
				path: this.DOM.path[0],
				align: this.DOM.path[0],
				alignOrigin: [1, 0.85],
				autoRotate: true,
			},
		});

		tl.to(
			this.DOM.path,
			{
				keyframes: [{ drawSVG: "40% 60%" }, { drawSVG: "95.5% 95.5%" }],
				duration: 1.85,
			},
			0
		);

		tl.to(
			this.DOM.pathTop,
			{
				keyframes: [
					{ drawSVG: "28% 40%" },
					{ drawSVG: "45% 60%" },
					{ drawSVG: "95.5% 95.5%" },
				],
				duration: 2,
			},
			0
		);

		tl.to(
			this.DOM.pathBottom,
			{
				keyframes: [
					{ drawSVG: "34% 40%" },
					{ drawSVG: "47% 68%" },
					{ drawSVG: "95.5% 95.5%" },
				],
				duration: 2,
			},
			0
		);
	}

	planeWobble() {
		const tl = gsap.timeline({
			defaults: {
				duration: 0.4,
				ease: "power1.inOut",
			},
			repeat: -1,
			yoyo: true,
		});

		tl.to(this.DOM.planeGroup[0], {
			rotationZ: -0.3,
			transformOrigin: "100% 100%",
		});

		tl.to(
			this.DOM.planeGroup[1],
			{
				rotationZ: 0.3,
				transformOrigin: "100% 100%",
			},
			0
		);

		return tl;
	}

	createTimeline() {
		gsap.set(this.DOM.wrap, { autoAlpha: 1 });

		const mm = gsap.matchMedia();

		watchPreferredMotion(() => {
			/* Animate */
			this.planeFlight();
			this.planeWobble();
		});
	}
}
